import { chainsToNetworkTypes } from "./types.js";
export const createRegistryConnector = (wallet, isMobilePlatform, providerName) => ({
    id: wallet.id,
    name: wallet.name,
    icon: wallet.icon,
    type: 'walletConnect',
    source: 'registry',
    order: wallet.order,
    isMobileSupported: wallet.isMobileSupported,
    hasBrowserExtension: wallet.hasBrowserExtension,
    installUrl: wallet.installUrl,
    extensionNotFound: wallet.hasBrowserExtension ? !isMobilePlatform : false,
    providerName,
    networkTypes: chainsToNetworkTypes(wallet.chains),
    mobile: wallet.mobile,
});
